import { graphType } from "./Common";

// 表示文字列(日英対応)
export const languageType = {
  ja: 0,
  en: 1,
};

// 表示文字列(選択フォーム)
export const dataGraphSelectLabel = {
  Customer: ["拠点名", "Customer's Information"],
  Date: ["日付(Y/M/D)", "Date(Y/M/D)"],
  Range: ["日付範囲", "Date Range"],
  DisplayItem: ["表示項目", "Display Item"],
};

// 表示文字列(データグラフ)
export const dataGraphLabel = {
  axisX: (type) => {
    let value = "-";
    if (type === graphType.lr) value = "Left(-) / Right(+)";
    if (type === graphType.fb) value = "Front(-) / Rear(+)";

    return `${value} Direction , Eccentric distance from bolster center / mm`;
  },
  axisY: "Load / kN",
  lineShot1: "～100shots",
  lineShot2: "～1000shots",
  lineShot3: "～5000shots",
  lineShot4: "～10000shots",
  lineShot5: "～20000shots",
  lineShot6: "～30000shots",
  lineShot7: "30001shots～",
};

// 表示文字列(データテーブル)
export const dataTableLabel = {
  partNo: ["製品番号", "Part No"],
  shot: ["Shot数", "Shot Count"],
  eccentricity: [
    (type) => {
      let value = "-";
      if (type === graphType.lr) value = "Left(-) / Right(+)";
      if (type === graphType.fb) value = "Front(-) / Rear(+)";

      return `偏心量、\n${value}`;
    },
    (type) => {
      let value = "-";
      if (type === graphType.lr) value = "Left(-) / Right(+)";
      if (type === graphType.fb) value = "Front(-) / Rear(+)";

      return `Eccentric distance ,\n${value}`;
    },
  ],
  load: ["合計荷重 (平均)", "Total Load (Average)"],
};

// グラフ設定
export const chartSetting = {
  x: {
    min: -2500,
    max: 2500,
    step: 100,
  },
  y: {
    min: -8000,
    max: 40000,
    step: 1000,
  },
};

// 表示グラフ選択リスト(SelectTextField)
export const chartType = [
  {
    value: "shot",
    label: ["荷重 - Shot数単位", "Load - Shot"],
  },
  {
    value: "product",
    label: ["荷重 - 製品単位", "Load - Part"],
  },
];

// 表示期間選択リスト(SelectTextField)
export const rangeType = [
  {
    value: "Month",
    label: ["当月累計", "Cumulative total for 1 month"],
  },
  {
    value: "Today",
    label: ["当日", "Today"],
  },
];
